'use client'

import { scan } from 'react-scan'
import { useEffect } from 'react'

export function ReactScan(): React.ReactElement {
  useEffect(() => {
    scan({
      enabled: true,
    })
  }, [])

  return <></>
}
